<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">ZD-BOX型号详情</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" label-width="125px">
          <div class="flex">
            <div class="flex-1">
              <el-form-item label="型号名称：" prop="stationName">
                <el-input :disabled="stationDisabled" v-model="detailForm.stationName" size="small" />
              </el-form-item>
              <el-form-item label="型号编号：" prop="parkRate">
                <el-input :disabled="stationDisabled" v-model="detailForm.parkRate" size="small" />
              </el-form-item>
              <el-form-item label="储能电池数量：">
                <el-input :disabled="stationDisabled" v-model="detailForm.stationName" size="small" />
              </el-form-item>
              <el-form-item label="储能电池总容量：">
                <el-input :disabled="stationDisabled" v-model="detailForm.stationName" size="small" />
              </el-form-item>
            </div>
            <div class="flex-1"></div>
          </div>
        </el-form>
      </div>
      <!-- 操作 -->
      <div class="detail-content-footer-div">
        <button class="common-bg-button" @click="submitForm('detailForm')">
          提 交
        </button>
        <button class="common-empty-button" @click="resetForm">取 消</button>
      </div>
    </div>
  </div>
</template>

<script>
  import pageConfig from './page-config'
  export default {
    data() {
      return {
        pageConfig,
        stationDisabled: false, //是否作废充电桩
        calcList: [], // 计费方式
        // 默认值设置
        detailForm: {
          enableStatus: 'N',
          occupyStatus: 'N',
          calcWay: '01',
          clientSide: '01',
        },
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      // 初始化
      init() {
        let _ = this;
        if (_.$route.query.id) {
          _.$store.state.editId = _.$route.query.id
        }
        if (_.$store.state.editId) {
          _.stationStatusFlag = true
        }
        // 计费方式
        _.$H.post(_, _.$A.config.list, {configType: '200'}).then((res) => {
          _.calcList = res.data.data
        })
      },

      // 提交表单
      submitForm(formName) {
        let _ = this
        // 站点图片
        _.$refs[formName].validate((valid) => {
          if (valid) {

          }
        })
      },
      // 取消
      resetForm() {
        let _ = this;
        _.$router.push({ name: 'ZDBoxModelManage' })
      },
    },
  }
</script>

<style lang="less" scoped></style>
